import React from 'react';
import { Button } from '@sequelae/lore-core';
import { useNavigationMode } from '../contexts/NavigationModeContext';
import './NavigationModeToggle.css';

export const NavigationModeToggle: React.FC = () => {
  const { mode, toggleMode } = useNavigationMode();

  return (
    <button
      onClick={toggleMode}
      className="nav-mode-toggle"
      title={`Current: ${mode === 'native' ? 'Native-like' : 'Web-like'} Navigation`}
    >
      {mode === 'native' ? '📱' : '🔗'} {mode === 'native' ? 'Native-like' : 'Web-like'}
    </button>
  );
};
